import React, { Component } from 'react';
import { Debounce } from 'react-throttle';

import SelectionMenu from './SelectionMenu';
import FilterSet from './FilterSet';

import '../../../css/TrackFilter.css';
import '../../../css/SearchBar.css';

class TrackFilter extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      match: props.match,
      loved: props.loved || false,
      forgotten: props.forgotten || false,
      sort: props.sort || 'top'
    }

    this.onChange = (query) => {
      this.setState(query); 
      props.onChange(query);
    };

  }

  componentDidMount() {
    if (this.refs.searchValue && this.refs.searchValue !== this.state.match) {
      this.refs.searchValue.value = this.state.match;
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      match: newProps.match,
      loved: newProps.loved || false,
      forgotten: newProps.forgotten || false,
      sort: newProps.sort || 'top'
    });
  }

  currentQuery() {
    return {
      match: this.state.match,
      loved: this.state.loved,
      forgotten: this.state.forgotten,
      sort: this.state.sort
    }; 
  }

  search(evt) {
    evt.preventDefault();
    let match = evt.target.value;
    let query = this.currentQuery();
    query.match = match.trim().toLowerCase();
    this.onChange(query);
  }

  toggleLoved() {
    let query = this.currentQuery();
    query.loved = !query.loved;
    this.onChange(query);
  }

  toggleForgotten() {
    let query = this.currentQuery();
    query.forgotten = !query.forgotten;
    this.onChange(query);
  }

  selectSort(sort) {
    let query = this.currentQuery();
    query.sort = sort;
    this.onChange(query);
  }

  render() {

    let active = (value) => value ? 'active' : '';

    let sorts = ['top', 'latest'];

    return (

      <div>

        <Debounce time="300" handler="onChange">
          <input type="text" ref="searchValue" onChange={this.search.bind(this)} className="searchBar" placeholder="Search"/>        
        </Debounce>

        <div className="filters">

          <label className={`clickable ${active(this.state.loved)}`} onClick={this.toggleLoved.bind(this)}>Loved</label>
          <label className={`clickable ${active(this.state.forgotten)}`} onClick={this.toggleForgotten.bind(this)}>Forgotten</label>
          
          <FilterSet>
            <SelectionMenu title="sort" selectedItem={this.state.sort} items={sorts} select={this.selectSort.bind(this)}/>
          </FilterSet>

        </div>



    </div>
  );

  }

}

export default TrackFilter;



// WEBPACK FOOTER //
// ./src/js/components/filter/TrackFilter.jsx